import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import Dashboard from 'ui/dashboard/Dashboard';
import DashboardBox from 'ui/dashboard/Box';
import DashboardBoxActions from 'ui/dashboard/BoxActions';
import DashboardBoxContent from 'ui/dashboard/BoxContent';
import WhiteBack from '../../../WhiteBack';

import { ActionTypes } from '../Consts';

const styles = theme => ({
    contentHeader: {
        margin: `${theme.spacing(2)}px 0`,
    },
});

export function ConnectorDashboard({
    installed,
    instaling,
    editable,
    connectors,
    onAction,
    allowed,
}) {
    const isExists = ids => id => ids.includes(id);
    const isInstaling = isExists(instaling);
    const isInstalled = isExists(installed);
    const visibleConnectors = connectors.filter(
        connector => !isInstalled(connector.identifier)
    );
    if (!visibleConnectors.length) {
        return <WhiteBack />;
    }
    const title = installed.length
        ? 'Available connectors'
        : 'Choose a connector to install';
    return (
        <Dashboard
            title={title}
            subtitle="Available to all companies on an Advanced subscription"
        >
            {visibleConnectors.map(config => {
                const { identifier, box } = config;
                return (
                    <ConnectorBox
                        key={identifier}
                        content={box}
                        allowed={allowed}
                        instaling={isInstaling(identifier)}
                        editable={
                            editable &&
                            installed.length === 0 &&
                            instaling !== 0
                        }
                        onAction={type => onAction(type, { identifier })}
                    />
                );
            })}
        </Dashboard>
    );
}

export const ConnectorBoxContent = withStyles(styles)(
    ({ logo, title, description, classes }) => {
        return (
            <React.Fragment>
                {logo && <img src={logo} alt={title} />}
                <Typography variant="h5" className={classes.contentHeader}>
                    {title}
                </Typography>
                <Typography color="textSecondary">{description}</Typography>
            </React.Fragment>
        );
    }
);

function findBoxContentComponent(content) {
    if (React.isValidElement(content)) {
        return content;
    }
    if (content.component) {
        if (React.isValidElement(content.component)) {
            return content.component;
        }
        const Component = content.component;
        return <Component />;
    }
    return (
        <ConnectorBoxContent
            title={content.title}
            description={content.description}
            logo={content.logo}
        />
    );
}

export const ConnectorBox = ({
    content,
    instaling,
    editable,
    onAction,
    allowed,
}) => {
    return (
        <DashboardBox>
            <DashboardBoxContent>
                {findBoxContentComponent(content)}
            </DashboardBoxContent>
            {editable && (
                <DashboardBoxActions>
                    <Button
                        color="secondary"
                        onClick={() =>
                            onAction(
                                allowed
                                    ? ActionTypes.INSTALL
                                    : ActionTypes.REDIRECT
                            )
                        }
                        disabled={instaling}
                    >
                        {allowed ? 'Install' : 'Upgrade my account'}
                    </Button>
                </DashboardBoxActions>
            )}
        </DashboardBox>
    );
};
